import NewWidget from '@/UI/Website/NewWidget/NewWidget';
import { CHAT_PAGE_ACCESS_TOKEN_KEY, getPreviewIdentityToken } from '@/context';

// Full-screen mobile widget from the TopBar "Preview" button; embed view renders its own close (quickchat_minimize).
export const MobilePreviewDialog = ({ onClose }: { onClose: () => void }) => {
  const token = getPreviewIdentityToken();
  const customParams = token ? { [CHAT_PAGE_ACCESS_TOKEN_KEY]: token } : undefined;

  return (
    <div className="fixed inset-0 z-50 bg-background">
      <NewWidget
        showViewModeToggle={false}
        fixedViewType="embed"
        source="preview"
        className="h-full"
        customParams={customParams}
        showCloseButton
        onMinimize={onClose}
        bindContextIframe={false}
      />
    </div>
  );
};
